const disableSimplifiedInterface = function({ commit }) {
  localStorage.setItem("simplified-interface-hidden", true);
  commit('disableSimplifiedInterface');
};

export { disableSimplifiedInterface };
